import { render } from "./SFDP.vue?vue&type=template&id=6fcaeaaf&scoped=true"
import script from "./SFDP.vue?vue&type=script&lang=js"
export * from "./SFDP.vue?vue&type=script&lang=js"

import "./SFDP.vue?vue&type=style&index=0&id=6fcaeaaf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fcaeaaf"],['__file',"src/components/SFDP.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6fcaeaaf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6fcaeaaf', __exports__)) {
    api.reload('6fcaeaaf', __exports__)
  }
  
  module.hot.accept("./SFDP.vue?vue&type=template&id=6fcaeaaf&scoped=true", () => {
    api.rerender('6fcaeaaf', render)
  })

}


export default __exports__